import React from "react";
import { useState, useEffect, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import Pdf2ImagePDFListScreen from "./Pdf2ImagePDFListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function Pdf2ImageMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Convert PDF to JPG, PNG, SVG, WEBP, BMP Securely",
  };
  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/pdf_to_image", title: "PDF to .png" },
    data2: { link: "/pdf_to_image", title: "PDF to image" },
    data3: { link: "/pdf_to_image", title: "Extract pdf pages as image" },
  };

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert PDF to image online easily. Turn PDF pages into JPG or PNG images quickly with our fast, secure, and easy PDF to image converter."
      ></meta>
      <meta
        name="keywords"
        content="pdf to image, pdf to image converter, convert pdf to image, pdf to jpg, pdf to png, pdf pages to images, online pdf to image, pdf to photo, pdf image converter, extract images from pdf, convert pdf pages to jpg, pdf to png converter, pdf to picture, pdf file to image, pdf converter online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <Pdf2ImagePDFListScreen title={title}></Pdf2ImagePDFListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF to JPG Converter website offers a fast, secure, and efficient way to convert PDF documents into high-quality images without requiring an internet connection. Designed to work fully offline, this powerful image converter allows users to transform PDF pages into JPG, JPEG, PNG, WEBP, or SVG formats while keeping all processing on the device for maximum privacy. Whether you need to extract images, share documents on social platforms, or use PDF content in presentations, this tool makes conversion simple and reliable. Users can convert files using PDF to JPG online or choose offline processing for sensitive documents, enjoying the flexibility of an advanced online converter with offline capabilities. The platform supports multiple output formats, including PDF to PNG online, PDF to JPEG, PDF to WEBP, and PDF to SVG, making it suitable for a wide range of use cases. With options to export each page individually or PDF to single image, users have full control over the final output. Optimized for speed and clarity, the converter preserves image resolution, colors, and sharp text during conversion. Ideal for students, designers, professionals, and businesses, this website provides a seamless way to convert PDFs into images using a secure PDF to JPG converter, PDF to image converter, and online converter solution that works both offline and online." />
          {/* How to use define max 4 steps */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Extract",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF to image converter"
            why_use={[
              {
                title: "Convert PDF to Image Easily",
                description:
                  "Our PDF to image converter allows you to quickly convert PDF files into JPG, PNG, SVG, WEBP, and BMP formats for better usability and accessibility.",
              },
              {
                title: "Best Offline PDF to Image Converter",
                description:
                  "Using an offline PDF to image converter ensures secure PDF conversion, as files are processed locally without uploading to the internet.",
              },
              {
                title: "Universal File Compatibility Across Devices",
                description:
                  "Image formats created using a PDF to JPG converter or PDF to PNG converter can be opened on any device without a PDF reader.",
              },

              {
                title: "High-Quality PDF to Image Conversion",
                description:
                  "Preserve original layout, fonts, and colors with high-resolution PDF to image conversion for professional results.",
              },
              {
                title: "Multiple Image Format Support",
                description:
                  "Choose the right format using a PDF to JPG, PDF to PNG, PDF to SVG, PDF to WEBP, or PDF to BMP converter based on your requirements.",
              },
              {
                title: "No Software Installation Needed",
                description:
                  "A browser-based PDF to image converter online offline works instantly without downloading or installing any software.",
              },
              {
                title: "Perfect for Design, Marketing & Presentations",
                description:
                  "Converted images can be used in graphic design, social media marketing, PowerPoint presentations, and website content.",
              },
              {
                title: "Free & User-Friendly PDF to Image Tool",
                description:
                  "Our free PDF to image converter saves time and boosts productivity for students, professionals, and businesses.",
              },
              {
                title: "Faster Sharing & Downloading",
                description:
                  "Image files created by a PDF to image conversion tool are easier to share via email, messaging apps, and cloud platforms.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I convert PDF to images online for free?",
                description:
                  "You can convert a PDF into images using a PDF-to-image converter. Select your PDF, choose a supported image format such as JPG or PNG, adjust the available settings, and download the converted images."
              },
              {
                title: "What is a PDF to image converter?",
                description:
                  "A PDF-to-image converter transforms PDF pages into image files. It is useful for sharing individual pages, creating previews, using document pages in presentations, and viewing PDF content in image-compatible applications."
              },
              {
                title: "Can I convert PDF to images offline?",
                description:
                  "Yes, if the PDF-to-image tool supports offline processing. A browser-based converter that processes files locally can convert PDF pages on your device after the website and required resources have loaded."
              },
              {
                title: "Does ShivaPDF convert PDF to images locally in my browser?",
                description:
                  "Local processing means your PDF pages are converted directly in your browser instead of being uploaded to a remote server. Check that the PDF to Image tool on ShivaPDF.com supports local processing before converting confidential documents."
              },
              {
                title: "Can I convert PDF to JPG without uploading the file?",
                description:
                  "Yes, if the converter processes the PDF entirely locally in your browser. Your document can then remain on your device rather than being sent to a server. Confirm local processing support before converting sensitive files."
              },
              {
                title: "Is it safe to convert PDF files into images online?",
                description:
                  "Choose a trusted PDF-to-image converter and review its privacy practices. For confidential documents, consider a tool that processes files locally without uploading them to a remote server."
              },
              {
                title: "Can I convert PDF to JPG?",
                description:
                  "Yes, a PDF-to-JPG converter transforms PDF pages into JPG image files. JPG is commonly used for photographs, previews, website content, and sharing document pages as images."
              },
              {
                title: "Can I convert PDF to PNG?",
                description:
                  "Yes, if PNG output is supported, you can convert PDF pages into PNG images. PNG is useful for graphics, diagrams, screenshots, and content where crisp edges or transparency may be important."
              },
              {
                title: "Which image formats are supported for PDF conversion?",
                description:
                  "Supported output formats depend on the converter. Common choices include JPG, JPEG, and PNG. Check the format options available in the PDF to Image tool before converting your document."
              },
              {
                title: "Can I convert every page of a PDF into an image?",
                description:
                  "A PDF-to-image tool can convert multiple pages into separate image files when batch page conversion is supported. The number of pages you can process may depend on the tool and your device's available memory."
              },
              {
                title: "Can I convert only selected PDF pages into images?",
                description:
                  "If page selection is supported, you can choose specific pages or a page range to convert instead of processing the entire PDF. Check the tool's page selection options before starting."
              },
              {
                title: "Can I convert a multi-page PDF into separate JPG images?",
                description:
                  "Yes, if multi-page conversion is supported, each PDF page can be exported as an individual JPG image. This makes it easier to share, organize, and use specific pages separately."
              },
              {
                title: "Will converting PDF to images reduce quality?",
                description:
                  "Image quality depends on the output resolution, image format, and compression settings. Choosing a suitable resolution can help preserve readable text, clear diagrams, and detailed images."
              },
              {
                title: "Can I choose the image resolution when converting a PDF?",
                description:
                  "Some PDF-to-image converters provide resolution or DPI settings. Higher resolution generally produces more detailed images but also increases file size. Available settings depend on the tool."
              },
              {
                title: "What is the difference between JPG and PNG for PDF conversion?",
                description:
                  "JPG uses lossy compression and is often suitable for photographs and smaller image files. PNG uses lossless compression and is often better for text, diagrams, screenshots, and images requiring transparency."
              },
              {
                title: "Can I convert a scanned PDF to images?",
                description:
                  "Yes, scanned PDFs can generally be converted into images because their pages already contain visual content. The resulting quality depends on the original scan and the selected output settings."
              },
              {
                title: "Can I convert PDF to images on my mobile phone?",
                description:
                  "You can use a mobile-compatible PDF-to-image converter on an Android phone, iPhone, or tablet. Performance depends on the browser, PDF size, number of pages, and available device memory."
              },
              {
                title: "Can I convert PDF to images on Windows and Mac?",
                description:
                  "Yes, a compatible browser-based PDF-to-image tool can work on Windows and macOS. If local processing is supported, you can convert PDF pages directly in the browser without installing separate software."
              },
              {
                title: "Do I need to install software to convert PDF to JPG?",
                description:
                  "A browser-based PDF-to-image converter can let you create JPG images without installing a separate application. Depending on its offline capabilities, an internet connection may still be required to load the website."
              },
              {
                title: "Can I convert large PDF files into images?",
                description:
                  "Large PDFs and documents with many pages may require additional processing time and memory. The maximum supported file size depends on the converter, browser, and device resources."
              },
              {
                title: "Can I convert a password-protected PDF into images?",
                description:
                  "A password-protected PDF may require the correct password before its pages can be converted. Support depends on the document's security settings and the capabilities of the conversion tool."
              },
              {
                title: "Why are my converted PDF images blurry?",
                description:
                  "Blurry images can result from low output resolution, compression, or a low-quality original PDF. If resolution settings are available, choose a higher value and check the results before downloading all images."
              },
              {
                title: "Why can't I download the converted images?",
                description:
                  "Make sure conversion has finished and your browser permits downloads. If downloading fails, try again, check available storage, and confirm that your browser supports the tool's output format."
              },
              {
                title: "Is the PDF to Image tool on ShivaPDF free to use?",
                description:
                  "Visit the PDF to Image page on ShivaPDF.com to check current availability, supported formats, file-size limits, and usage restrictions. Features and limits depend on the tool's current implementation."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1632843204}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default Pdf2ImageMain;
